import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import {INavigationBar} from '@wearesection/bandai-react-components/organisms/EStoreNavigationBar';
import theme from '@wearesection/bandai-react-components/theme';
import Cookies from 'js-cookie';
import {useRouter} from 'next/router';
import React, {ReactNode, useEffect, useMemo, useRef, useState} from 'react';
import {convertToSlug, handleConvertToLocaleContentful} from '~/utils';

import {
  // handleChangeLocale,
  handleConvertRegionTranslation,
  handleDetectDefaultLocale,
  handleDetectShowUpdateLocale,
  handleRedirectLanguageUtil,
} from '~/utils/locale-handler';

import {PLACEHOLDER_IMG} from '~/constants';
import {usePageSetting} from '~/providers/page-context.provider';
import {getGloablByType} from '~/utils/global-operations';

type IData = {
  title: string;
  href: string;
  imageUrl?: string;
};

type IDataPopular = {
  title: string;
  items: IData[];
};

import dynamic from 'next/dynamic';
import {GLOBAL_TYPE} from '~/constants/content-map-type';
import {cloneDeep} from 'lodash';
import {useSelector} from 'react-redux';
import RenderNextLink from '../../atoms/render-next-link';
import getListGameLatest from './get-list-game-latest';
import {getLitGameNavigationPopular} from './get-list-navigation-popular';
import getListGameFeatured from './get-list-game-featured';
import {getListMenuEvent} from './get-list-menu-event';
import {handelFormatTitleStatus} from '../store-order-detail/store-order-detail';
import {setCookie} from 'cookies-next';
import LocalStorage, {TITLE_LOCAL_STORAGE} from '~/local-storage/local-storage';
import countryApi from '~/pages/api/services/country-api';

const NavigationBar = dynamic(
  () => import('@wearesection/bandai-react-components/organisms/EStoreNavigationBar'),
  {
    ssr: false,
  }
);

const InstantSearchCustom = dynamic(() => import('./instant-search'), {
  ssr: false,
});

const NavigationBarOrganisms = (props: INavigationBar) => {
  const router = useRouter();
  const {pathname, asPath, query, locales, locale, defaultLocale, route} = router;
  const [dataSubMenu, setDataSubMenu] = useState({});
  const [dataSubMenuEvent, setDataSubMenuEvent] = useState<any[]>([]);
  const [isShowSearch, setIsShowSearch] = useState<boolean>(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDesktop = useMediaQuery(theme.breakpoints.down('xl'));
  const refTimeOut = useRef<any>();
  const [hadCart, setHadCart] = useState<boolean>(false);
  const [dataMenu, setDataMenu] = useState<any>({});
  const listCart = useSelector((state: any) => state?.cart?.listCart || []);
  const user = useSelector((state: any) => state?.user?.dataUser);

  const {
    openSearchPopup,
    setOpenSearchPopup,
    globalData,
    statusShowBannerUpdateLocale,
    setStatusShowBannerUpdateLocale,
    dataSlug,
  } = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};

  const LIST_KEY_POPULAR: any = {
    'PlayStation 4': 'filter-game-platform-playstation-4',
    'Nintendo 3DS': 'filter-game-platform-nitendo-3ds',
    'PlayStation 5': 'filter-game-platform-playstation-5',
    'XBOX 360': 'filter-game-platform-xbox-360',
    'XBOX One': 'filter-game-platform-xbox-one',
    'XBOX Series X': 'filter-game-platform-xbox-series-x',
    'XBOX Series X|S': 'filter-game-platform-xbox-series-xs',
    'Nintendo 3DS XL': 'filter-game-platform-nitendo-3ds-xl',
    'Nintendo Switch': 'filter-game-platform-nitendo-switch',
    PC: 'filter-game-platform-pc',
    Action: 'game-genre-action',
    Adventure: 'game-genre-adventure',
    Anime: 'game-genre-anime',
    'Arcade classics': 'game-genre-arcade-classics',
    'Card/RPG': 'game-genre-card-rpg',
    Fighting: 'game-genre-fighting',
    'First person shooter': 'game-genre-first-person-shooter',
    'Flight/combat': 'game-genre-flight-combat',
    'Free-to-play': 'game-genre-free-to-play',
    Horror: 'game-genre-horror',
    'Massive multiplayer online (MMO)': 'game-genre-massive-multiplayer-online-mmo',
    ' Multiplayer online battle arena (MOBA)': 'game-genre-multiplayer-online-battle-arena-moba',
    'Park management': 'game-genre-park-management',
    Puzzle: 'game-genre-puzzle',
    Racing: 'game-genre-racing',
    'Real time strategy': 'game-genre-real-time-strategy',
    Rhythm: 'game-genre-rhythm',
    'Role playing (RPG)': 'game-genre-role-playing-rpg',
    Shooting: 'game-genre-shooting',
    Simulation: 'game-genre-simulation',
    Sports: 'game-genre-sports',
    Strategy: 'game-genre-strategy',
    Tactical: 'game-genre-tactical',
    Variety: 'game-genre-variety',
    '0 - 50': 'estore-product-filter-price-0-50',
    '50 - 100': 'estore-product-filter-price-50-100',
    '100 - 150': 'estore-product-filter-price-100-150',
    'Under S$50': 'estore-product-filter-price-under-50',
    'On sale': 'estore-product-filter-price-on-sale',
  };

  const ctx: any = {
    locales: locales,
    locale: locale,
    defaultLocale: defaultLocale,
  };

  const cookieCountry = Cookies.get('user-country');
  const isLoginSuccess = Cookies.get('isLoginSuccess');

  const handelCheckCurrentForLocale = (lc: string) => {
    //kr-ko
    if (lc === 'ko-kr') {
      return 'KRW';
    }
    //hk-tw
    const current = Cookies.get('currentToken');
    if (['tc'].includes(lc)) {
      if (['HKD', 'TWD'].includes(current)) {
        return current;
      }
      return 'HKD';
    }

    return ['HKD', 'TWD', 'KRW'].includes(current) ? 'SGD' : current || 'SGD';
  };

  const currentToken = handelCheckCurrentForLocale(`${locale}`.toLowerCase());
  const dataTrending = (globalData as any)?.dataPopularTrending ?? {};

  useEffect(() => {
    if (listCart?.length) {
      setHadCart(true);
      return;
    } else {
      setHadCart(false);
    }
  }, [hadCart, listCart]);

  const handleGetListGameLatest = (dataSub: any, type: any, translation: any) => {
    getListGameLatest(handleConvertToLocaleContentful(ctx.locale as string), type).then(
      (dataGameLatest: any) => {
        const dataLatest: IDataPopular = {
          title: translation['title-latest'],
          items: [],
        };
        !!dataGameLatest?.length &&
          dataGameLatest.map((item: any) => {
            const data: IData = {
              title: item?.title ?? '',
              href: `/${locale}/store/games/${convertToSlug(item?.title)}` ?? '/',
            };
            dataLatest.items.push(data);
          });
        dataSub.subMenu[0] = dataLatest;

        setDataSubMenu({...dataSub});
      }
    );
  };

  const handleGetListGameFeatured = (dataSub: any, type: any, translation: any) => {
    getListGameFeatured(handleConvertToLocaleContentful(ctx.locale as string), type).then(
      (listGameFeatured: any) => {
        const dataOurPickClone = listGameFeatured ?? [];
        const dataOurPick: any = {
          title: translation['estore-title-featured'],
          items:
            dataOurPickClone?.map((item: any) => ({
              title: item.title ?? '',
              imageUrl: item.mainImage ?? PLACEHOLDER_IMG,
              href: `/${locale}/store/games/${convertToSlug(item?.title)}` ?? '/',
            })) ?? [],
        };
        dataSub.ourPicks = dataOurPick;
        setDataSubMenu({
          ...dataSub,
          ourPicks: dataOurPick,
        });
      }
    );
  };

  useEffect(() => {
    const handleGetData = async () => {
      const promises: [
        ReturnType<typeof getGloablByType>,
        ReturnType<typeof getGloablByType>,
        ReturnType<typeof getLitGameNavigationPopular>,
        ReturnType<typeof getListMenuEvent>
      ] = [
        getGloablByType(
          handleConvertToLocaleContentful(ctx.locale as string),
          GLOBAL_TYPE.translation
        ),
        getGloablByType(
          handleConvertToLocaleContentful(ctx.locale as string),
          GLOBAL_TYPE.StoreTab
        ),
        getLitGameNavigationPopular(handleConvertToLocaleContentful(ctx.locale as string)),
        getListMenuEvent(handleConvertToLocaleContentful(ctx.locale as string)),
      ];
      const [dataTranslation, tabList, listPopular, dataListEvent] = await Promise.all(promises);
      let dataSub: any = [];

      const dataMenuSub: any = [
        {
          title: dataTranslation['title-latest'],
          items: [],
        },
      ];

      // Popular
      const dataPopular: IDataPopular = {
        title: dataTranslation['title-popular'] ?? '',
        items: [],
      };

      if (listPopular?.price?.length) {
        listPopular.price.map((item: any) => {
          const data: IData = {
            title: dataTranslation[LIST_KEY_POPULAR[item]] || item,
            href: `/${ctx?.locale}/store/games?pr=${item}`,
          };
          dataPopular.items.push(data);
        });
      }

      if (listPopular?.genre?.length) {
        listPopular.genre.map((item: any) => {
          const data: IData = {
            title: dataTranslation[LIST_KEY_POPULAR[item]] || item,
            href: `/${ctx?.locale}/store/games?gr=${item}`,
          };
          dataPopular.items.push(data);
        });
      }

      if (listPopular?.platform?.length) {
        listPopular.platform.map((item: any) => {
          const data: IData = {
            title: dataTranslation[LIST_KEY_POPULAR[item]] || item,
            href: `/${ctx?.locale}/store/games?p=${item}`,
          };
          dataPopular.items.push(data);
        });
      }
      dataMenuSub.push(dataPopular);
      dataSub = {
        subMenu: dataMenuSub,
        ourPicks: {
          title: dataTranslation['estore-title-featured'],
          items: [],
        },
      };
      setDataSubMenu(dataSub);
      handleGetListGameLatest(dataSub, tabList?.games_listing?.[0]?.value, dataTranslation);
      handleGetListGameFeatured(dataSub, tabList?.games_listing?.[0]?.value, dataTranslation);

      // format data event
      const dataEvent: any[] = [];
      if (dataListEvent?.length) {
        dataListEvent.map(item => {
          const newItem = {
            title: item?.title || '',
            imageUrl: item?.thumnail || PLACEHOLDER_IMG,
            // mainImageNext: (
            //   <RenderNextImage src={item?.thumnail || PLACEHOLDER_IMG} width={292} height={202} />
            // ),
            href: `/store/deal?id=${item?.id}&deal=${convertToSlug(item?.title)}&st=${
              item?.start_date?.substr(0, 10) || ''
            }&et=${item?.end_date?.substr(0, 10) || ''}`,
          };
          dataEvent.push(newItem);
        });
      }
      setDataSubMenuEvent(dataEvent.splice(0, 4) ?? []);
    };
    handleGetData();
  }, []);

  const handleReturnHref = (item: any, dataSlug: any, locale: string) => {
    const splitPathName = router.route.split('/');
    const localeTrim = locale?.slice(0, 2);

    if (item.label === '繁體中文') {
      //tw-tc
      if (splitPathName?.length >= 3) {
        if (dataSlug['zh-Hant']) {
          return `/${localeTrim === 'tw' ? 'tw-tc' : 'hk-tc'}/${splitPathName[1]}/${
            dataSlug['zh-Hant']
          }`;
        }
        return `/${localeTrim === 'tw' ? 'tw-tc' : 'hk-tc'}`;
      }
      return `/${localeTrim === 'tw' ? 'tw-tc' : 'hk-tc'}${router.asPath}`;
    }

    if (item.label === '简体中文') {
      //tw-tc
      if (splitPathName?.length >= 3) {
        if (dataSlug['zh-Hans']) {
          return `/${localeTrim === 'tw' ? 'tw-sc' : 'hk-sc'}/${splitPathName[1]}/${
            dataSlug['zh-Hans']
          }`;
        }
        return `/${localeTrim === 'tw' ? 'tw-sc' : 'hk-sc'}`;
      }
      return `/${localeTrim === 'tw' ? 'tw-sc' : 'hk-sc'}${router.asPath}`;
    }
  };

  // update data menu
  const handleUpdateMenu = (dataSubMenu: any, dataSubMenuEvent: any[]) => {
    const dataClone: any = {...props};
    const index = (dataClone?.menuProps ?? []).findIndex((item: any) =>
      item.link?.includes('/store/games')
    );
    if (index !== -1) {
      dataClone.menuProps[index] = {
        ...dataClone.menuProps[index],
        ...dataSubMenu,
      };
    }
    const indexDealEvent = (dataClone?.menuProps ?? []).findIndex((item: any) =>
      item.link?.includes('/store/deal')
    );
    if (indexDealEvent !== -1) {
      dataClone.menuProps[indexDealEvent] = {
        ...dataClone.menuProps[indexDealEvent],
        subMenu: dataSubMenuEvent || [],
      };
    }
    // propsSearch
    dataClone.propsSearch = {
      ...dataClone.propsSearch,
      href: `/${locale}`,
      hrefSeeAll: `/${locale}/`,
    };

    // update url
    if (dataClone?.menuProps?.length) {
      const newMenuProps = dataClone.menuProps.map((item: any) => {
        if (item?.link === '/store/games') {
          item.seeAll.href = `/${locale}/store/games`;
        }
        return {
          ...item,
          link: item?.link.includes('http') ? item?.link : `/${locale}${item?.link}`,
        };
      });
      dataClone.menuProps = newMenuProps;
    }

    // update signInOut
    if (dataClone?.signInOut?.length) {
      const newSignInOut = cloneDeep(dataClone?.signInOut).map((item: any) => {
        return {
          ...item,
          href: `/${locale}${item?.href || ''}`,
        };
      });
      if (isLoginSuccess) {
        dataClone.signInOut = newSignInOut.splice(2, 3);
      } else {
        dataClone.signInOut = newSignInOut.splice(0, 2);
      }
    }

    // update href icon props
    if (dataClone?.iconProps?.length) {
      const newIconProps = cloneDeep(dataClone?.iconProps).map((item: any) => {
        if (item?.href === '/cart') {
          return {
            ...item,
            href: `/${locale}${item?.href || ''}`,
          };
        }
        return item;
      });

      dataClone.iconProps = newIconProps;
    }

    //update button props
    if (dataClone?.buttonProps?.length) {
      const newButtonProps = dataClone.buttonProps.map((item: any) => {
        return {
          ...item,
          externalLink: `/${locale}${item?.externalLink}`,
        };
      });

      dataClone.buttonProps = newButtonProps;
    }

    dataClone.logged = !!isLoginSuccess;
    // update shippingDefault and  contentModalChangeShipping
    if (
      dataClone?.contentModalChangeShipping?.listCountryShipping?.length &&
      currentToken !== 'SGD'
    ) {
      dataClone.shippingDefault = dataClone.contentModalChangeShipping.listCountryShipping.find(
        (item: any) => item.currency === currentToken
      );
      dataClone.contentModalChangeShipping.note = `${
        dataTranslation['estore-change-location-shipping-current']
      }${`${locale}`.toLowerCase() === 'tc' ? '' : ' '}<strong>${
        dataClone?.shippingDefault?.name || ''
      }.</strong><br>${dataTranslation['estore-change-location-order-billed']}${
        `${locale}`.toLowerCase() === 'tc' ? '' : ' '
      }<strong>${dataClone?.shippingDefault?.currency || ''} (${
        dataClone?.shippingDefault?.symbol || ''
      })</strong>${`${locale}`.toLowerCase() === 'tc' ? ' 顯示.' : '.'}`;
    }

    // update infoUser
    dataClone.infoUser = {
      ...dataClone.infoUser,
      name: `${dataTranslation['estore-account-welcome-hi'] || ''} ${handelFormatTitleStatus(
        user?.first_name || user?.last_name
      )}${`${locale}`.toLowerCase() === 'ko-kr' ? '님' : ''} `,
    };

    const localeTrim = locale?.slice(0, 2);

    const newLanguages = dataClone?.languages?.map((item: any) => {
      return {
        ...item,
        href: handleReturnHref(item, dataSlug, locale ?? ''),
      };
    });

    if (dataClone?.languages) {
      dataClone.languages = newLanguages;
    }
    if (localeTrim === 'hk' || localeTrim === 'tw') {
      if (locale === 'tw-sc' || locale === 'hk-sc') {
        dataClone.languagesDefault = '简体中文';
      } else {
        dataClone.languagesDefault = '繁體中文';
      }
    }

    dataClone.locale = `${locale}`.toLowerCase();
    dataClone.listSubEmpty = dataTranslation['estore-navigation-list-event-empty'] || '';
    return dataClone;
  };

  // update menu for re-render
  const dataSubMenuMemo = useMemo(
    () => handleUpdateMenu(dataSubMenu, dataSubMenuEvent),
    [locale, dataSubMenu, dataSubMenuEvent, isLoginSuccess, user, currentToken]
  );

  const handleChangeShippingCountry = (v: any) => {
    if (v) {
      setCookie('currentToken', v?.currency || 'SGD', {
        httpOnly: false,
      });
      setCookie('currentValue', JSON.stringify(v));
      LocalStorage.setItem(TITLE_LOCAL_STORAGE.navigation, {
        ...dataSubMenuMemo,
        shippingDefault: v,
        contentModalChangeShipping: {
          ...dataSubMenuMemo.contentModalChangeShipping,
          note: `${dataTranslation['estore-change-location-shipping-current']} <strong>${
            v?.name || ''
          }.</strong><br>${dataTranslation['estore-change-location-order-billed']} <strong>${
            v?.currency || ''
          } (${v?.symbol || ''}).</strong>`,
        },
      });
    }

    window.location.href = `${window.location.origin}${window.location.pathname}${
      window.location.search || ''
    }`;
  };

  useEffect(() => {
    if (
      query?.currency_code &&
      dataMenu?.contentModalChangeShipping?.listCountryShipping?.length &&
      query?.currency_code !== currentToken &&
      Object.keys(dataSubMenuMemo)?.length
    ) {
      const itemCurrency = dataMenu.contentModalChangeShipping.listCountryShipping.find(
        (item: any) => item?.currency === query?.currency_code
      );
      if (itemCurrency) {
        handleChangeShippingCountry(itemCurrency);
      }
      return;
    }

    //check save currency locale ko-kr
    if (`${locale}`.toLowerCase() === 'ko-kr') {
      const shippingDefault = dataSubMenuMemo.shippingDefault;
      setCookie('currentToken', shippingDefault?.currency || 'SGD', {
        httpOnly: false,
      });
      setCookie('currentValue', JSON.stringify(shippingDefault));
    }

    //check save currency locale sea
    if (dataSubMenuMemo?.shippingDefault && !['KRW'].includes(currentToken)) {
      const shippingDefault = dataSubMenuMemo.shippingDefault;
      setCookie('currentToken', shippingDefault?.currency || 'SGD', {
        httpOnly: false,
      });
      setCookie('currentValue', JSON.stringify(shippingDefault));
    }
  }, [query, dataMenu, dataSubMenuMemo]);

  useEffect(() => {
    setDataMenu(dataSubMenuMemo);
  }, [dataSubMenuEvent, dataSubMenuMemo, dataSubMenu]);

  const handleSetShowBannerCountry = async (current: string, cookieCountry: any) => {
    try {
      const countryData = await countryApi.getIP(
        'https://geolocation-db.com/json/f2e84010-e1e9-11ed-b2f8-6b70106be3c8'
      );

      const country = countryData?.data?.country_code || '';

      if (!country) {
        setStatusShowBannerUpdateLocale(
          !handleDetectShowUpdateLocale(
            // show banner update locale
            cookieCountry,
            router?.locale?.toLocaleLowerCase() ?? 'sea'
          )
        );
        return;
      }
      if (country === 'TW' && current === 'TWD') {
        setStatusShowBannerUpdateLocale(false);
        return;
      }
      if (country === 'HK' && current === 'HKD') {
        setStatusShowBannerUpdateLocale(false);
        return;
      }
      if (country === 'KR' && current === 'KRW') {
        setStatusShowBannerUpdateLocale(false);
        return;
      }
      setStatusShowBannerUpdateLocale(
        !handleDetectShowUpdateLocale(
          // show banner update locale
          cookieCountry,
          router?.locale?.toLocaleLowerCase() ?? 'sea'
        )
      );
    } catch (error) {
      setStatusShowBannerUpdateLocale(
        !handleDetectShowUpdateLocale(
          // show banner update locale
          cookieCountry,
          router?.locale?.toLocaleLowerCase() ?? 'sea'
        )
      );
    }
  };

  useEffect(() => {
    if (currentToken && cookieCountry && typeof window !== undefined) {
      handleSetShowBannerCountry(currentToken, cookieCountry);
    }
  }, [cookieCountry, currentToken]);

  const handleCloseBannerRevamp = () => {
    setStatusShowBannerUpdateLocale(false);
    if (typeof window !== 'undefined' && pathname !== '/store/games/[slug]') {
      document.body.style.paddingTop = isMobile ? '73px' : isDesktop ? '80px' : '96px';
    } else {
      document.body.style.paddingTop = '0px';
    }
  };

  const handleRedirectLanguage = (selectedLang: string) => {
    if (`${locale}`.toLowerCase() !== 'tc') {
      setCookie('currentToken', '');
    }
    handleRedirectLanguageUtil(selectedLang, router, pathname, query, asPath, dataSlug);
  };

  const listSlugsTranparentTheme: any = {'/games/[slug]': '/games/[slug]'};
  if (typeof window !== 'undefined') {
    if (statusShowBannerUpdateLocale) {
      document.body.style.paddingTop = listSlugsTranparentTheme[route]
        ? '0px'
        : isMobile
        ? '228px'
        : isDesktop
        ? '178px'
        : '194px';
    } else {
      document.body.style.paddingTop = listSlugsTranparentTheme[route]
        ? '0px'
        : isMobile
        ? '73px'
        : isDesktop
        ? '80px'
        : '96px';
    }
  }

  const [detectScrollTop, setDetectScrollTop] = React.useState(0);
  const [renderNavibarTheme, setRenderNavibarTheme] = React.useState<any>('transparent');

  if (typeof window !== 'undefined') {
    window.onscroll = function () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (refTimeOut.current) {
        window.clearTimeout(refTimeOut.current);
      }
      refTimeOut.current = setTimeout(() => {
        refTimeOut.current = undefined;
        if (scrollTop === 0) {
          setDetectScrollTop(scrollTop);
          return;
        }
        if (scrollTop !== 0 && detectScrollTop === 0) {
          setDetectScrollTop(scrollTop);
        }
      }, 200);
    };
  }

  React.useEffect(() => {
    setRenderNavibarTheme(
      listSlugsTranparentTheme[route] && detectScrollTop === 0 ? 'transparent' : 'light'
    );
  }, [detectScrollTop, listSlugsTranparentTheme, route]);

  const handleCloseSearchForm = () => {
    setIsShowSearch(false);
    setOpenSearchPopup(false);
  };

  useEffect(() => {
    setIsShowSearch(openSearchPopup);
  }, [openSearchPopup]);

  const handleShowTrending = () => {
    // setShowHits(false);
  };

  const InstantSearchMemo = useMemo(
    () => (
      <InstantSearchCustom
        locale={locale ?? ''}
        handleCloseSearchForm={handleCloseSearchForm}
        isShowSearch={isShowSearch}
        handleShowTrending={handleShowTrending}
        dataSubMenuMemo={dataMenu}
        dataTrending={dataTrending}
      />
    ),
    [locale, isShowSearch, dataMenu, dataTrending]
  );

  return (
    <Box
      sx={{
        position: 'relative',
        pointerEvents: 'auto',
      }}
      className="home_page_store"
    >
      <Box
        sx={{
          zIndex: '10',
        }}
      >
        {typeof window && (
          <NavigationBar
            {...dataMenu}
            theme={(renderNavibarTheme as any) ?? 'light'}
            defaultLocation={handleDetectDefaultLocale(cookieCountry)}
            handleCloseBannerRevamp={handleCloseBannerRevamp}
            locationPrompt={{
              ...(dataMenu as any)?.locationPrompt,
              isShowLocation: statusShowBannerUpdateLocale,
              defaultLocation: handleConvertRegionTranslation(
                handleDetectDefaultLocale(cookieCountry),
                locale as string
              ),
            }}
            handleShowLayoutSearch={() => {
              setIsShowSearch(true);
            }}
            handleRedirectLanguage={handleRedirectLanguage}
            handleLogout={() => router.push({pathname: '/logout'})}
            nextLink={(href: string, child: ReactNode) => (
              <RenderNextLink href={href} child={child} />
            )}
            notify={hadCart}
            onChangeShippingCountry={handleChangeShippingCountry}
          />
        )}
      </Box>
      <Box
        sx={{
          width: '100vw',
          minHeight: {
            xs: '100vh',
            md: '100px',
          },
          padding: {
            xs: '26px 0px 24px 0',
            md: '40px 0px 24px 0',
          },
          position: 'fixed',
          top: isShowSearch ? '0px' : 'calc(-100vh - 50%)',
          transition: 'all 0.6s',
          background: '#fff',
          opacity: '1',
          zIndex: '50',

          '&::after': {
            content: '" "',
            width: '100%',
            height: '1px',
            backgroundColor: '#EAEAEA',
            position: 'absolute',
            bottom: '-1px',
          },
        }}
      >
        {InstantSearchMemo}
      </Box>

      <Box
        sx={{
          visibility: isShowSearch ? 'visible' : 'hidden',
          position: 'fixed',
          minHeight: isShowSearch ? '100vh' : '0px',
          width: '100%',
          background: '#1E1E1E',
          opacity: isShowSearch ? '0.8' : '0',
          zIndex: '5',
          transition: 'all 0.3s',
          bottom: '0px',
          top: '0px',
        }}
        onClick={() => {
          setIsShowSearch(false);
          setOpenSearchPopup(false);
        }}
      />
    </Box>
  );
};

export default React.memo(NavigationBarOrganisms);
